import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page43',
  templateUrl: './page43.component.html',
  styleUrls: ['./page43.component.css']
})
export class Page43Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
